/* Scripts for the dedicated single-product template (product.heirloom-edition) only.
   1) title="Немає в наявності" tooltip on sold-out color swatches (re-applied after the variant picker re-renders).
   2) Loading state on the Add-to-cart buttons while the /cart/add request is in flight (spinner via CSS on [data-cy-loading]); kept visible at least 400ms so a fast response still gives feedback and a double click is impossible. The cart drawer itself is opened by the theme's own product-form / cart-drawer code after a successful add (the drawer's auto-open attribute is switched on for this template in snippets/cart-drawer.liquid).
   3) Clicking the dimmed overlay (drawn as .page-wrapper--drawer-open::after in chuyou-fix3.css) closes the cart drawer -- the theme's drawer is non-modal, so it has no outside-click handling of its own.
   4) Photo lightbox: the theme's zoom dialog (scroll container = the <dialog>, slides scrolled with scrollIntoView) is turned into a one-photo-at-a-time viewer by CSS; this script only adds the parts the theme lacks -- prev/next arrows (desktop), an "N / M" counter, ArrowLeft/ArrowRight keys and a horizontal swipe on touch screens (the theme's drag-zoom-wrapper calls preventDefault on every touch inside the photo, so native scroll-snap swiping never reaches the dialog; the dialog is touch-action: none in CSS and the swipe is read here). No second zoom implementation: opening, closing (x button, Esc, click) and high-res loading stay the theme's zoom-dialog.js.
   5) Reviews summary ("Підсумок відгуків"): a "Читати більше" / "Згорнути" toggle button under the text. The 3-line clamp itself and the button's visibility are pure CSS and apply below 768px only; on desktop the button is hidden and the full text stays visible.
   6) FAQ block ("Залишились питання?"): the link `a[href="#cy-add-to-cart"]` ("Додай у кошик →") scrolls the main Add-to-cart button to the middle of the screen and focuses it; there is no element with that id, so the handler is the only thing the link does (without it the browser would just append the hash to the URL). */
(function () {
  var main = document.getElementById('MainContent');
  if (!main || main.dataset.template !== 'product.heirloom-edition') return;

  function apply() {
    document.querySelectorAll('.variant-option__button-label').forEach(function (label) {
      var input = label.querySelector('input');
      if (!input) return;
      if (input.dataset.optionAvailable === 'false') {
        if (label.title !== 'Немає в наявності') label.title = 'Немає в наявності';
      } else if (label.hasAttribute('title')) {
        label.removeAttribute('title');
      }
    });
  }

  var timer = null;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(apply, 30);
  }

  apply();
  new MutationObserver(schedule).observe(main, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-option-available'] });

  function setLoading(on) {
    document.querySelectorAll('main .add-to-cart-button, .sticky-add-to-cart__button').forEach(function (btn) {
      if (btn.classList.contains('quick-add__button')) return;
      if (on) {
        btn.setAttribute('data-cy-loading', 'true');
        btn.setAttribute('aria-busy', 'true');
      } else {
        btn.removeAttribute('data-cy-loading');
        btn.removeAttribute('aria-busy');
      }
    });
  }

  var originalFetch = window.fetch;
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    if (!/\/cart\/add(\.js)?(\?|$)/.test(url)) return originalFetch.apply(this, arguments);

    var started = Date.now();
    setLoading(true);
    var request = originalFetch.apply(this, arguments);
    var finish = function () {
      setTimeout(function () { setLoading(false); }, Math.max(0, 400 - (Date.now() - started)));
    };
    request.then(finish, finish);
    return request;
  };

  document.addEventListener('click', function (event) {
    var wrapper = document.querySelector('.page-wrapper--drawer-open');
    if (!wrapper || event.target !== wrapper) return;
    var close = document.querySelector('#cart-drawer .theme-drawer__close-button, #cart-drawer [aria-label="Close"]');
    if (close) close.click();
  });

  var ARROW = '<svg aria-hidden="true" width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M12.5 4.5 7 10l5.5 5.5"/></svg>';

  function setupLightbox(dialog) {
    if (dialog.__cyLightbox) return dialog.__cyLightbox.update;

    function slides() {
      return dialog.querySelectorAll('.dialog-zoomed-gallery > .product-media-container');
    }

    function makeButton(dir, label) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'cy-lb-nav cy-lb-nav--' + dir;
      b.setAttribute('aria-label', label);
      b.innerHTML = ARROW;
      return b;
    }

    var prev = makeButton('prev', 'Попереднє фото');
    var next = makeButton('next', 'Наступне фото');
    var counter = document.createElement('div');
    counter.className = 'cy-lb-counter';
    counter.setAttribute('aria-live', 'polite');

    function index() {
      return Math.round(dialog.scrollLeft / (dialog.clientWidth || 1));
    }

    function update() {
      var total = slides().length;
      var i = Math.min(Math.max(index(), 0), Math.max(total - 1, 0));
      counter.textContent = (i + 1) + ' / ' + total;
      prev.disabled = i <= 0;
      next.disabled = i >= total - 1;
      var single = total < 2;
      prev.hidden = next.hidden = counter.hidden = single;
    }

    function go(step) {
      var total = slides().length;
      var target = Math.min(Math.max(index() + step, 0), total - 1);
      dialog.scrollTo({ left: target * dialog.clientWidth, behavior: 'smooth' });
    }

    prev.addEventListener('click', function (e) { e.stopPropagation(); go(-1); });
    next.addEventListener('click', function (e) { e.stopPropagation(); go(1); });
    dialog.addEventListener('scroll', update, { passive: true });
    dialog.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
    });

    var startX = 0;
    var startY = 0;
    var tracking = false;
    dialog.addEventListener('touchstart', function (e) {
      tracking = e.touches.length === 1;
      if (tracking) {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
      }
    }, { passive: true, capture: true });
    dialog.addEventListener('touchend', function (e) {
      if (!tracking) return;
      tracking = false;
      var t = e.changedTouches[0];
      var dx = t.clientX - startX;
      var dy = t.clientY - startY;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) go(dx < 0 ? 1 : -1);
    }, { passive: true, capture: true });

    dialog.appendChild(prev);
    dialog.appendChild(next);
    dialog.appendChild(counter);
    dialog.__cyLightbox = { update: update };
    update();
    return update;
  }

  function initLightboxes() {
    document.querySelectorAll('.dialog-zoomed-gallery__dialog').forEach(setupLightbox);
  }

  initLightboxes();
  new MutationObserver(function (records) {
    records.forEach(function (record) {
      var dialog = record.target;
      if (!dialog.matches || !dialog.matches('.dialog-zoomed-gallery__dialog')) return;
      var update = setupLightbox(dialog);
      if (dialog.open) requestAnimationFrame(function () { requestAnimationFrame(update); });
    });
  }).observe(document.body, { attributes: true, attributeFilter: ['open'], subtree: true });

  function setupSummaryToggle() {
    var text = document.querySelector('[class*="__text_reviewssummary1"]');
    if (!text || text.__cySummary) return;
    text.__cySummary = true;
    text.classList.add('cy-summary');

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'cy-summary-toggle';
    button.textContent = 'Читати більше';
    button.setAttribute('aria-expanded', 'false');
    button.addEventListener('click', function () {
      var open = text.classList.toggle('cy-summary--open');
      button.textContent = open ? 'Згорнути' : 'Читати більше';
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    text.insertAdjacentElement('afterend', button);
  }

  setupSummaryToggle();

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a[href="#cy-add-to-cart"]');
    if (!link) return;
    event.preventDefault();
    var button = document.querySelector('main .product-form-buttons .add-to-cart-button') || document.querySelector('main .add-to-cart-button:not(.quick-add__button)');
    if (!button) return;
    button.scrollIntoView({ behavior: 'smooth', block: 'center' });
    setTimeout(function () { button.focus({ preventScroll: true }); }, 450);
  });
})();
